import React, {useEffect, useState} from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ButtonAction from '../../../_common/components/ButtonAction';
import PopupDeleteFile from '../../../_common/components/PopupDeleteFile/PopupDeleteFile';
import {useOldInspectionDocumentsContext} from '../OldInspectionsDocumentsContext';
import ButtonUpdateFileType from './ButtonUpdateFileType';
import ButtonEditFileName from './ButtonEditFileName';
import ButtonViewFile from '../../../_common/components/ButtonViewFile';
import PopupEditDocSyncFusion from '../../../_common/components/PopupEditDocSyncFusion';
import {getFilePreview} from '../../actions/TabDocumentsActions';
import Thumbnail from '../../../_common/components/Thumbnail';
import FileIcon from '../../../_common/components/FileIcon';
import ButtonDD from "../../../_common/components/ButtonDD";
import styles from '../styles.module.scss';

interface FileItemProps {
  shumaID: number,
  fileID: number,
  fileName: string,
  fileExtension: string,
  uploadTime: Date,
  fileTypeID: number,
  fileTypeName: string,
  folderID: number,
  uploadedByUserID: number,
  uploadedByUserFirstName: string,
  uploadedByUserLastName: string,
  link: string,
  thumbnail?: string,
}

export function FileItem({
                           shumaID,
                           fileID,
                           uploadTime,
                           fileName,
                           fileExtension,
                           fileTypeID,
                           fileTypeName,
                           uploadedByUserFirstName,
                           uploadedByUserLastName,
                           thumbnail
                         }: FileItemProps) {
  const {
    handleDownloadFile,
    handleDeleteFile,
    handleViewFile,
    updateEditedFile,
    updateFileList
  } = useOldInspectionDocumentsContext();
  const isOfficeDocument = fileExtension === 'doc' || fileExtension === 'docx';
  const handleFileUpdate = (file: Blob) => updateEditedFile(fileID, file);
  const [data, setData] = useState('');

  useEffect(() => {
    if (isOfficeDocument) {
      getFilePreview({shumaID, fileID})
        .then(result => {
          setData(result || '');
        });
    }
  }, [shumaID, fileID]);

  return (
    <div key={fileID} className={styles.row}>
      <Thumbnail fileExtension={fileExtension} uri={thumbnail} fileToSave={null}/>
      <div className={classnames(styles.cell, 'badge', 'text-dark-75 font-weight-bolder font-size-lg text-nowrap')}>
        <div className={styles.dateCell}>
          {uploadTime ? moment(uploadTime).format('DD-MM-YYYY') : ''}
        </div>
      </div>
      <div className={styles.cell}>
        {[uploadedByUserFirstName, uploadedByUserLastName].filter(Boolean).join(' ')}
      </div>
      <div className={classnames(styles.cell, 'd-flex align-items-center')}>
        <ButtonEditFileName fileID={fileID} fileName={fileName}/>
        <div className="ml-2 text-truncate" title={fileName}>{fileName}</div>
      </div>
      <div className={styles.cell}>
        <FileIcon fileExtension={fileExtension} size={'sm'}/>
      </div>
      <div className={classnames(styles.cell, 'd-flex align-items-center')}>
        <ButtonUpdateFileType fileID={fileID} fileTypeID={fileTypeID}/>
        <div className="ml-2 text-truncate" title={fileTypeName}>{fileTypeName || '...'}</div>
      </div>
      <div className={styles.lastCell}>
        <ButtonDD
          label={null}
          items={[{
            itemContent: (
              <div className="d-flex justify-content-between align-items-center">
                {!isOfficeDocument && (
                  <ButtonViewFile
                    fileExtension={fileExtension}
                    onClick={() => handleViewFile(fileID)}
                  />
                )}
                {isOfficeDocument && data && (
                  <PopupEditDocSyncFusion
                    docName={fileName}
                    file={data}
                    onSave={handleFileUpdate}
                    updateFileList={updateFileList}
                  />
                )}
                <div className={'mx-2'}/>
                <PopupDeleteFile
                  fileName={fileName}
                  onDelete={() => handleDeleteFile(fileID)}
                />
                <div className={'mx-2'}/>
                <ButtonAction
                  iconButtonType={'secondary'}
                  variant={'icon'}
                  label={
                    <img
                      src={'../../../media/common/Download_secondary.svg'}
                      alt="download" className="w-20px h-20px"
                    />
                  }
                  onClick={() => handleDownloadFile(fileID, fileName)}
                  disabled={false}
                />
              </div>
            )
          }
          ]}
        />
      </div>
    </div>
  );
}